module.exports = __webpack_public_path__ + "img/go11.5ccb8d87.png";